import { jsx as _jsx } from "react/jsx-runtime";
import { Tag, Tooltip } from "antd";
import { ETemplateStatus } from "@devowl-wp/api-real-cookie-banner";
const TemplateMetaDataStatusTag = ({ status, toolTip })=>/*#__PURE__*/ _jsx(Tooltip, {
        title: toolTip,
        placement: "bottom",
        children: /*#__PURE__*/ _jsx(Tag, {
            color: status === ETemplateStatus.Published ? "blue" : "yellow",
            children: status === ETemplateStatus.Published ? "PUBLISHED" : "DRAFT"
        })
    });
export { TemplateMetaDataStatusTag };
